import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  fetchTotalFundsRaised,
  downloadCsv,
  TotalFundsRaisedResponse,
  TotalFundsRaisedRow,
} from '~/services/predefinedReports';
import { PredefinedResultsLayout, Column } from './PredefinedResultsLayout';

const columns: Column<TotalFundsRaisedRow>[] = [
  { key: 'medical_center', label: 'Medical Center' },
  { key: 'location', label: 'Location' },
  { key: 'patient_last_name', label: 'Patient last' },
  { key: 'patient_first_name', label: 'First' },
  { key: 'patient_middle_name', label: 'Middle' },
  { key: 'total_funds_raised', label: 'Total raised', rightAlign: true },
  { key: 'status', label: 'Status' },
  { key: 'status_date', label: 'Status date' },
  { key: 'medical_reason', label: 'Medical reason' },
  { key: 'primary_issue', label: 'Type 1' },
  { key: 'secondary_issue', label: 'Type 2' },
];

const TotalFundsRaisedByMedCenterResults: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState<TotalFundsRaisedResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = {
      location: searchParams.get('location') || undefined,
      medical_center: searchParams.get('medical_center') || undefined,
    };
    setLoading(true);
    fetchTotalFundsRaised(params)
      .then((d) => { setData(d); setError(null); })
      .catch((e) => { setError(e.message); setData(null); })
      .finally(() => setLoading(false));
  }, [searchParams]);

  const subtitle = data?.location
    ? `Location: ${data.location}${data.medical_center_ids.length ? ` · ${data.medical_center_ids.length} center(s)` : ''}`
    : 'All locations';

  return (
    <PredefinedResultsLayout
      title='Total Funds Raised by Medical Center'
      subtitle={subtitle}
      columns={columns}
      rows={data?.rows ?? []}
      loading={loading}
      error={error}
      rowKey={(r) => r.patient_id}
      onDownloadCsv={() => downloadCsv('total-funds-raised-by-med-center', searchParams)}
    />
  );
};

export default TotalFundsRaisedByMedCenterResults;
